
export default{
    userOnlineTime: '用户在线时长TOP10',
    userFrequencyTime: '用户访问频次TOP10',
    pageVisitTime: '页面访问频次TOP10',
    pageStopTime: '页面停留时间',
    timeHour: '时长(小时)',
    times: '次数(次)',
    frequency: '频次(次)'
}



// WEBPACK FOOTER //
// ./src/config/i18n/zh-cn/userBehaviorAnalysis.js